import styled from 'styled-components';

import { size } from '../layout/helpers';
import { fontBold } from '../layout/font';

export const Wrapper = styled.article`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  transform-origin: 50% 50%;
  transition: transform 150ms ease;

  &:active {
    transform: scale(0.98);
  }

  &:has(a:focus-visible) {
    outline: 0.125rem solid var(--color-border-focus, #1959ca);
    outline-offset: var(--focus-outline-offset, 0.125rem);
  }
`;

export const Image = styled.div`
  flex-shrink: 0;
  position: relative;
  height: 0;
  padding-bottom: 66.666%;
  background-color: var(--element-accent-color, ${(props) => props.theme.color.accentDark});
  border-radius: var(--image-border-radius, 3px);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: inherit;
    opacity: 0;
    transition: opacity 200ms ease;
  }

  ${Wrapper}:hover & {
    &:before {
      opacity: 1;
    }
  }
`;

export const Picture = styled.picture``;

export const Source = styled('source')<{ type?: string; srcSet?: string; sizes?: string }>``;

export const Img = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: auto;
  left: auto;
  border-radius: var(--image-border-radius, 3px);
`;

export const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin-top: ${size(2)};
`;

export const ContentBody = styled.div``;

export const ContentFooter = styled.div`
  margin-top: auto;
  padding-top: ${size(1)};
`;

export const Heading = styled.h1`
  ${fontBold};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 400;
  margin: 0;
  font-size: 1rem;
`;

export const Link = styled.a`
  display: block;
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: none;
  }
`;

export const Description = styled.div`
  font-size: 0.875rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: ${size(0.25)};
`;

export const Usp = styled.div`
  margin-top: ${size(1)};
`;

export const Price = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const CurrentPrice = styled.div`
  ${fontBold};
  font-size: 1rem;
  color: var(--element-color, ${(props) => props.theme.color.primary});
  margin-right: ${size(1)};
`;

export const PriceCell = styled.div`
  flex: 1 1 auto;
  padding-right: ${size(1)};
`;

export const OldPrice = styled.div`
  text-decoration: line-through;
  color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
  font-size: 0.875rem;
`;

export const Label = styled.div`
  color: ${(props) => props.theme.color.disabledText};
  font-size: 0.875rem;
`;

export const PreHeading = styled.div`
  color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
  font-size: 0.75rem;
  margin-bottom: ${size(0.5)};
`;
